import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M26.7694 33.3334H12.7658L11.6431 34.6275C11.5262 34.8617 11.5262 35.1375 11.6431 35.3725L12.2881 36.6667H27.2429L27.8879 35.3725C28.0048 35.1384 28.0048 34.8617 27.8879 34.6275L26.7694 33.3334Z",
                fill: "url(#paint0_linear_259_2474)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M25.9686 35H13.5662C13.1239 35 12.7656 34.6375 12.7656 34.19V32.9166H26.7692V34.19C26.7692 34.6375 26.4109 35 25.9686 35Z",
                fill: "url(#paint1_linear_259_2474)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M26.3567 33.3333H13.1784C12.839 33.3333 12.6455 32.9417 12.8489 32.6667L14.5786 30.3333C14.7342 30.1233 14.978 30 15.2375 30H24.2975C24.557 30 24.8008 30.1233 24.9565 30.3333L26.6861 32.6667C26.8896 32.9417 26.696 33.3333 26.3567 33.3333Z",
                fill: "url(#paint2_linear_259_2474)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M27.7404 36.9308L27.4858 37.2558C27.3302 37.4125 27.1185 37.5 26.8986 37.5H12.6232C12.4008 37.5 12.1875 37.41 12.031 37.2508L11.774 36.9183C11.6422 36.7292 11.5549 36.5442 11.5549 36.325V35L12.073 35.5983C12.2278 35.7492 12.4354 35.8333 12.6512 35.8333H26.9167C27.1416 35.8333 27.3574 35.7417 27.5138 35.58L27.9751 35V36.3217C27.9751 36.5425 27.8746 36.7542 27.7404 36.9308Z",
                fill: "url(#paint3_linear_259_2474)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.0875 17.3917V17.7167C14.6675 17.9584 14.2062 17.9084 13.9344 18.0667C13.9344 18.0417 13.9344 18.0167 13.9262 18C10.5657 17.4809 12.4741 18.2217 9.27755 16.2242C7.76204 15.2992 6.55952 12.9492 6.19712 11.2825C5.99945 10.4575 5.95003 9.62419 5.99121 8.80752C5.99945 8.60752 6.01592 8.40752 6.04063 8.20752C6.07357 7.99086 6.07357 7.84919 6.1477 7.53252C6.28772 6.98252 6.6666 6.48252 7.19373 6.16586C7.4573 6.00752 7.76204 5.89086 8.07503 5.84086C8.37154 5.78252 8.76689 5.80752 8.9728 5.84919C9.31873 5.89919 9.6729 5.94919 10.093 6.06586C9.9447 6.44919 9.70584 7.04086 9.55759 7.40752C9.31049 7.38252 9.02222 7.36586 8.73394 7.33252C8.53627 7.31586 8.51156 7.32419 8.39625 7.34086C8.30565 7.36586 8.21505 7.39086 8.13268 7.44919C7.96795 7.54919 7.83617 7.70752 7.78675 7.89919C7.77028 7.95752 7.74557 8.19919 7.7291 8.35752C7.70439 8.53252 7.69615 8.70752 7.68792 8.88252C7.64673 9.59086 7.6945 10.745 7.85923 11.4034C8.23481 12.9625 8.9728 14.5659 10.2 15.3659C11.4025 16.1742 13.0202 16.9 14.5769 17.2417L14.6592 17.2584C14.8899 17.3167 15.0546 17.1834 15.0875 17.3917Z",
                fill: "url(#paint4_linear_259_2474)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.5555 17.64C14.5143 17.3917 14.3216 17.1842 14.0629 17.1409C12.4733 16.8725 10.9479 16.265 9.7487 15.2792C8.56101 14.2734 7.80572 12.8542 7.54792 11.315C7.41202 10.5475 7.36425 9.75669 7.41038 8.96336C7.43508 8.56752 7.4565 8.17002 7.51004 7.77419C7.53969 7.53586 7.64347 7.35002 7.80325 7.21419C7.96304 7.08502 8.1533 7.02169 8.3518 7.03336C8.74138 7.08336 9.20262 7.10586 9.50655 7.15836C9.54691 7.16169 9.58315 7.16919 9.61527 7.17669C9.52137 7.43252 9.32782 7.74169 9.15073 8.04419L9.14003 8.06252C9.05766 8.20252 9.06013 8.38419 9.15979 8.52502C9.29487 8.71502 9.55597 8.75836 9.74376 8.62252C10.1111 8.35586 10.4562 8.09002 10.7758 7.60419C10.8507 7.47502 10.9282 7.32002 10.9677 7.09919C11.0138 6.88502 10.9677 6.54919 10.8005 6.31336C10.448 5.85502 10.1317 5.80169 9.88542 5.69919C9.37312 5.54586 8.99424 5.48586 8.55277 5.41086C7.91609 5.30919 7.23494 5.51419 6.75228 5.93169C6.25975 6.33669 5.94594 6.95752 5.87675 7.56336C5.82404 8.01169 5.77791 8.46336 5.77956 8.91752C5.7738 9.82502 5.86193 10.7417 6.07854 11.6384C6.50684 13.4267 7.51745 15.1284 8.97036 16.2509C10.2816 17.325 11.8539 17.905 13.4205 18.2742C13.4436 18.4559 13.4518 18.6392 13.4312 18.8234C13.4147 18.9842 13.3744 19.1425 13.3217 19.2967C13.2731 19.4442 13.1825 19.615 13.1223 19.71L13.0828 19.7717C12.9807 19.9317 12.9988 20.1475 13.1372 20.2875C13.2961 20.4492 13.5556 20.45 13.7154 20.2884C13.9163 20.0859 14.0333 19.915 14.156 19.705C14.2713 19.5009 14.3685 19.2842 14.4352 19.0559C14.5728 18.6017 14.6074 18.1125 14.5555 17.64Z",
                fill: "#FEDD30"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.5555 17.64C14.5143 17.3917 14.3216 17.1842 14.0629 17.1409C12.4733 16.8725 10.9479 16.265 9.7487 15.2792C8.56101 14.2734 7.80572 12.8542 7.54792 11.315C7.41202 10.5475 7.36425 9.75669 7.41038 8.96336C7.43508 8.56752 7.4565 8.17002 7.51004 7.77419C7.53969 7.53586 7.64347 7.35002 7.80325 7.21419C7.96304 7.08502 8.1533 7.02169 8.3518 7.03336C8.74138 7.08336 9.20262 7.10586 9.50655 7.15836C9.54691 7.16169 9.58315 7.16919 9.61527 7.17669C9.52137 7.43252 9.32782 7.74169 9.15073 8.04419L9.14003 8.06252C9.05766 8.20252 9.06013 8.38419 9.15979 8.52502C9.29487 8.71502 9.55597 8.75836 9.74376 8.62252C10.1111 8.35586 10.4562 8.09002 10.7758 7.60419C10.8507 7.47502 10.9282 7.32002 10.9677 7.09919C11.0138 6.88502 10.9677 6.54919 10.8005 6.31336C10.448 5.85502 10.1317 5.80169 9.88542 5.69919C9.37312 5.54586 8.99424 5.48586 8.55277 5.41086C7.91609 5.30919 7.23494 5.51419 6.75228 5.93169C6.25975 6.33669 5.94594 6.95752 5.87675 7.56336C5.82404 8.01169 5.77791 8.46336 5.77956 8.91752C5.7738 9.82502 5.86193 10.7417 6.07854 11.6384C6.50684 13.4267 7.51745 15.1284 8.97036 16.2509C10.2816 17.325 11.8539 17.905 13.4205 18.2742C13.4436 18.4559 13.4518 18.6392 13.4312 18.8234C13.4147 18.9842 13.3744 19.1425 13.3217 19.2967C13.2731 19.4442 13.1825 19.615 13.1223 19.71L13.0828 19.7717C12.9807 19.9317 12.9988 20.1475 13.1372 20.2875C13.2961 20.4492 13.5556 20.45 13.7154 20.2884C13.9163 20.0859 14.0333 19.915 14.156 19.705C14.2713 19.5009 14.3685 19.2842 14.4352 19.0559C14.5728 18.6017 14.6074 18.1125 14.5555 17.64Z",
                fill: "url(#paint5_radial_259_2474)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.5555 17.64C14.5143 17.3917 14.3216 17.1842 14.0629 17.1409C12.4733 16.8725 10.9479 16.265 9.7487 15.2792C8.56101 14.2734 7.80572 12.8542 7.54792 11.315C7.41202 10.5475 7.36425 9.75669 7.41038 8.96336C7.43508 8.56752 7.4565 8.17002 7.51004 7.77419C7.53969 7.53586 7.64347 7.35002 7.80325 7.21419C7.96304 7.08502 8.1533 7.02169 8.3518 7.03336C8.74138 7.08336 9.20262 7.10586 9.50655 7.15836C9.54691 7.16169 9.58315 7.16919 9.61527 7.17669C9.52137 7.43252 9.32782 7.74169 9.15073 8.04419L9.14003 8.06252C9.05766 8.20252 9.06013 8.38419 9.15979 8.52502C9.29487 8.71502 9.55597 8.75836 9.74376 8.62252C10.1111 8.35586 10.4562 8.09002 10.7758 7.60419C10.8507 7.47502 10.9282 7.32002 10.9677 7.09919C11.0138 6.88502 10.9677 6.54919 10.8005 6.31336C10.448 5.85502 10.1317 5.80169 9.88542 5.69919C9.37312 5.54586 8.99424 5.48586 8.55277 5.41086C7.91609 5.30919 7.23494 5.51419 6.75228 5.93169C6.25975 6.33669 5.94594 6.95752 5.87675 7.56336C5.82404 8.01169 5.77791 8.46336 5.77956 8.91752C5.7738 9.82502 5.86193 10.7417 6.07854 11.6384C6.50684 13.4267 7.51745 15.1284 8.97036 16.2509C10.2816 17.325 11.8539 17.905 13.4205 18.2742C13.4436 18.4559 13.4518 18.6392 13.4312 18.8234C13.4147 18.9842 13.3744 19.1425 13.3217 19.2967C13.2731 19.4442 13.1825 19.615 13.1223 19.71L13.0828 19.7717C12.9807 19.9317 12.9988 20.1475 13.1372 20.2875C13.2961 20.4492 13.5556 20.45 13.7154 20.2884C13.9163 20.0859 14.0333 19.915 14.156 19.705C14.2713 19.5009 14.3685 19.2842 14.4352 19.0559C14.5728 18.6017 14.6074 18.1125 14.5555 17.64Z",
                fill: "url(#paint6_radial_259_2474)"
            }),
            /*#__PURE__*/ _jsx("path", {
                opacity: "0.4",
                d: "M14.5555 17.64C14.5143 17.3917 14.3216 17.1842 14.0629 17.1409C12.4733 16.8725 10.9479 16.265 9.7487 15.2792C8.56101 14.2734 7.80572 12.8542 7.54792 11.315C7.41202 10.5475 7.36425 9.75669 7.41038 8.96336C7.43508 8.56752 7.4565 8.17002 7.51004 7.77419C7.53969 7.53586 7.64347 7.35002 7.80325 7.21419C7.96304 7.08502 8.1533 7.02169 8.3518 7.03336C8.74138 7.08336 9.20262 7.10586 9.50655 7.15836C9.54691 7.16169 9.58315 7.16919 9.61527 7.17669C9.52137 7.43252 9.32782 7.74169 9.15073 8.04419L9.14003 8.06252C9.05766 8.20252 9.06013 8.38419 9.15979 8.52502C9.29487 8.71502 9.55597 8.75836 9.74376 8.62252C10.1111 8.35586 10.4562 8.09002 10.7758 7.60419C10.8507 7.47502 10.9282 7.32002 10.9677 7.09919C11.0138 6.88502 10.9677 6.54919 10.8005 6.31336C10.448 5.85502 10.1317 5.80169 9.88542 5.69919C9.37312 5.54586 8.99424 5.48586 8.55277 5.41086C7.91609 5.30919 7.23494 5.51419 6.75228 5.93169C6.25975 6.33669 5.94594 6.95752 5.87675 7.56336C5.82404 8.01169 5.77791 8.46336 5.77956 8.91752C5.7738 9.82502 5.86193 10.7417 6.07854 11.6384C6.50684 13.4267 7.51745 15.1284 8.97036 16.2509C10.2816 17.325 11.8539 17.905 13.4205 18.2742C13.4436 18.4559 13.4518 18.6392 13.4312 18.8234C13.4147 18.9842 13.3744 19.1425 13.3217 19.2967C13.2731 19.4442 13.1825 19.615 13.1223 19.71L13.0828 19.7717C12.9807 19.9317 12.9988 20.1475 13.1372 20.2875C13.2961 20.4492 13.5556 20.45 13.7154 20.2884C13.9163 20.0859 14.0333 19.915 14.156 19.705C14.2713 19.5009 14.3685 19.2842 14.4352 19.0559C14.5728 18.6017 14.6074 18.1125 14.5555 17.64Z",
                fill: "url(#paint7_radial_259_2474)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M24.4473 17.3917V17.7167C24.8673 17.9584 25.3286 17.9084 25.6004 18.0667C25.6004 18.0417 25.6004 18.0167 25.6086 18C28.9691 17.4809 27.0607 18.2217 30.2572 16.2242C31.7728 15.2992 32.9753 12.9492 33.3377 11.2825C33.5353 10.4575 33.5848 9.62419 33.5436 8.80752C33.5353 8.60752 33.5189 8.40752 33.4942 8.20752C33.4612 7.99086 33.4612 7.84919 33.3871 7.53252C33.2471 6.98252 32.8682 6.48252 32.3411 6.16586C32.0775 6.00752 31.7727 5.89086 31.4598 5.84086C31.1633 5.78252 30.7679 5.80752 30.562 5.84919C30.2161 5.89919 29.8619 5.94919 29.4418 6.06586C29.5901 6.44919 29.829 7.04086 29.9772 7.40752C30.2243 7.38252 30.5126 7.36586 30.8009 7.33252C30.9985 7.31586 31.0232 7.32419 31.1385 7.34086C31.2291 7.36586 31.3197 7.39086 31.4021 7.44919C31.5668 7.54919 31.6986 7.70752 31.748 7.89919C31.7645 7.95752 31.7892 8.19919 31.8057 8.35752C31.8304 8.53252 31.8386 8.70752 31.8469 8.88252C31.8881 9.59086 31.7522 11.1675 31.5874 11.8259C31.258 13.1342 30.562 14.5659 29.3348 15.3659C28.1322 16.1742 26.5146 16.9 24.9579 17.2417L24.8756 17.2584C24.6449 17.3167 24.4802 17.1834 24.4473 17.3917Z",
                fill: "url(#paint8_linear_259_2474)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M25.1005 19.0567C25.1672 19.285 25.2644 19.5017 25.3797 19.7059C25.5025 19.9159 25.6194 20.0867 25.8204 20.2892C25.9802 20.45 26.2388 20.45 26.3986 20.2884C26.537 20.1484 26.5551 19.9325 26.4529 19.7725L26.4134 19.7109C26.3525 19.6159 26.2627 19.445 26.2141 19.2975C26.1606 19.1434 26.1202 18.985 26.1045 18.8242C26.0831 18.64 26.0922 18.4567 26.1153 18.275C27.6826 17.9059 29.2542 17.3259 30.5654 16.2517C32.0183 15.1284 33.0289 13.4275 33.4572 11.6392C33.673 10.7434 33.762 9.82588 33.7562 8.91838C33.757 8.46421 33.7117 8.01254 33.659 7.56421C33.5898 6.95754 33.276 6.33754 32.7843 5.93254C32.3008 5.51504 31.6205 5.31004 30.9838 5.41171C30.5423 5.48671 30.1635 5.54671 29.6512 5.70004C29.4049 5.80254 29.0886 5.85588 28.7361 6.31421C28.5681 6.55004 28.5219 6.88671 28.5689 7.10004C28.6084 7.32088 28.6858 7.47588 28.7608 7.60504C29.0804 8.09171 29.4255 8.35671 29.7928 8.62338C29.9806 8.76004 30.2417 8.71588 30.3768 8.52588C30.4764 8.38504 30.4789 8.20338 30.3965 8.06338L30.3842 8.04421C30.2071 7.74254 30.0136 7.43254 29.9188 7.17671C29.951 7.16921 29.988 7.16171 30.0276 7.15838C30.3315 7.10588 30.7927 7.08338 31.1823 7.03338C31.3808 7.02171 31.5711 7.08504 31.7317 7.21504C31.8915 7.35171 31.9952 7.53671 32.0249 7.77504C32.0776 8.17004 32.099 8.56838 32.1246 8.96421C32.1699 9.75671 32.1229 10.5484 31.987 11.3159C31.7292 12.8559 30.9731 14.275 29.7862 15.28C28.587 16.2659 27.0608 16.8734 25.472 17.1417C25.2134 17.185 25.0206 17.3925 24.9794 17.64C24.9276 18.1125 24.9622 18.6017 25.1005 19.0567Z",
                fill: "#FEDD30"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M25.1005 19.0567C25.1672 19.285 25.2644 19.5017 25.3797 19.7059C25.5025 19.9159 25.6194 20.0867 25.8204 20.2892C25.9802 20.45 26.2388 20.45 26.3986 20.2884C26.537 20.1484 26.5551 19.9325 26.4529 19.7725L26.4134 19.7109C26.3525 19.6159 26.2627 19.445 26.2141 19.2975C26.1606 19.1434 26.1202 18.985 26.1045 18.8242C26.0831 18.64 26.0922 18.4567 26.1153 18.275C27.6826 17.9059 29.2542 17.3259 30.5654 16.2517C32.0183 15.1284 33.0289 13.4275 33.4572 11.6392C33.673 10.7434 33.762 9.82588 33.7562 8.91838C33.757 8.46421 33.7117 8.01254 33.659 7.56421C33.5898 6.95754 33.276 6.33754 32.7843 5.93254C32.3008 5.51504 31.6205 5.31004 30.9838 5.41171C30.5423 5.48671 30.1635 5.54671 29.6512 5.70004C29.4049 5.80254 29.0886 5.85588 28.7361 6.31421C28.5681 6.55004 28.5219 6.88671 28.5689 7.10004C28.6084 7.32088 28.6858 7.47588 28.7608 7.60504C29.0804 8.09171 29.4255 8.35671 29.7928 8.62338C29.9806 8.76004 30.2417 8.71588 30.3768 8.52588C30.4764 8.38504 30.4789 8.20338 30.3965 8.06338L30.3842 8.04421C30.2071 7.74254 30.0136 7.43254 29.9188 7.17671C29.951 7.16921 29.988 7.16171 30.0276 7.15838C30.3315 7.10588 30.7927 7.08338 31.1823 7.03338C31.3808 7.02171 31.5711 7.08504 31.7317 7.21504C31.8915 7.35171 31.9952 7.53671 32.0249 7.77504C32.0776 8.17004 32.099 8.56838 32.1246 8.96421C32.1699 9.75671 32.1229 10.5484 31.987 11.3159C31.7292 12.8559 30.9731 14.275 29.7862 15.28C28.587 16.2659 27.0608 16.8734 25.472 17.1417C25.2134 17.185 25.0206 17.3925 24.9794 17.64C24.9276 18.1125 24.9622 18.6017 25.1005 19.0567Z",
                fill: "url(#paint9_radial_259_2474)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M25.1005 19.0567C25.1672 19.285 25.2644 19.5017 25.3797 19.7059C25.5025 19.9159 25.6194 20.0867 25.8204 20.2892C25.9802 20.45 26.2388 20.45 26.3986 20.2884C26.537 20.1484 26.5551 19.9325 26.4529 19.7725L26.4134 19.7109C26.3525 19.6159 26.2627 19.445 26.2141 19.2975C26.1606 19.1434 26.1202 18.985 26.1045 18.8242C26.0831 18.64 26.0922 18.4567 26.1153 18.275C27.6826 17.9059 29.2542 17.3259 30.5654 16.2517C32.0183 15.1284 33.0289 13.4275 33.4572 11.6392C33.673 10.7434 33.762 9.82588 33.7562 8.91838C33.757 8.46421 33.7117 8.01254 33.659 7.56421C33.5898 6.95754 33.276 6.33754 32.7843 5.93254C32.3008 5.51504 31.6205 5.31004 30.9838 5.41171C30.5423 5.48671 30.1635 5.54671 29.6512 5.70004C29.4049 5.80254 29.0886 5.85588 28.7361 6.31421C28.5681 6.55004 28.5219 6.88671 28.5689 7.10004C28.6084 7.32088 28.6858 7.47588 28.7608 7.60504C29.0804 8.09171 29.4255 8.35671 29.7928 8.62338C29.9806 8.76004 30.2417 8.71588 30.3768 8.52588C30.4764 8.38504 30.4789 8.20338 30.3965 8.06338L30.3842 8.04421C30.2071 7.74254 30.0136 7.43254 29.9188 7.17671C29.951 7.16921 29.988 7.16171 30.0276 7.15838C30.3315 7.10588 30.7927 7.08338 31.1823 7.03338C31.3808 7.02171 31.5711 7.08504 31.7317 7.21504C31.8915 7.35171 31.9952 7.53671 32.0249 7.77504C32.0776 8.17004 32.099 8.56838 32.1246 8.96421C32.1699 9.75671 32.1229 10.5484 31.987 11.3159C31.7292 12.8559 30.9731 14.275 29.7862 15.28C28.587 16.2659 27.0608 16.8734 25.472 17.1417C25.2134 17.185 25.0206 17.3925 24.9794 17.64C24.9276 18.1125 24.9622 18.6017 25.1005 19.0567Z",
                fill: "url(#paint10_radial_259_2474)"
            }),
            /*#__PURE__*/ _jsx("path", {
                opacity: "0.4",
                d: "M25.1005 19.0567C25.1672 19.285 25.2644 19.5017 25.3797 19.7059C25.5025 19.9159 25.6194 20.0867 25.8204 20.2892C25.9802 20.45 26.2388 20.45 26.3986 20.2884C26.537 20.1484 26.5551 19.9325 26.4529 19.7725L26.4134 19.7109C26.3525 19.6159 26.2627 19.445 26.2141 19.2975C26.1606 19.1434 26.1202 18.985 26.1045 18.8242C26.0831 18.64 26.0922 18.4567 26.1153 18.275C27.6826 17.9059 29.2542 17.3259 30.5654 16.2517C32.0183 15.1284 33.0289 13.4275 33.4572 11.6392C33.673 10.7434 33.762 9.82588 33.7562 8.91838C33.757 8.46421 33.7117 8.01254 33.659 7.56421C33.5898 6.95754 33.276 6.33754 32.7843 5.93254C32.3008 5.51504 31.6205 5.31004 30.9838 5.41171C30.5423 5.48671 30.1635 5.54671 29.6512 5.70004C29.4049 5.80254 29.0886 5.85588 28.7361 6.31421C28.5681 6.55004 28.5219 6.88671 28.5689 7.10004C28.6084 7.32088 28.6858 7.47588 28.7608 7.60504C29.0804 8.09171 29.4255 8.35671 29.7928 8.62338C29.9806 8.76004 30.2417 8.71588 30.3768 8.52588C30.4764 8.38504 30.4789 8.20338 30.3965 8.06338L30.3842 8.04421C30.2071 7.74254 30.0136 7.43254 29.9188 7.17671C29.951 7.16921 29.988 7.16171 30.0276 7.15838C30.3315 7.10588 30.7927 7.08338 31.1823 7.03338C31.3808 7.02171 31.5711 7.08504 31.7317 7.21504C31.8915 7.35171 31.9952 7.53671 32.0249 7.77504C32.0776 8.17004 32.099 8.56838 32.1246 8.96421C32.1699 9.75671 32.1229 10.5484 31.987 11.3159C31.7292 12.8559 30.9731 14.275 29.7862 15.28C28.587 16.2659 27.0608 16.8734 25.472 17.1417C25.2134 17.185 25.0206 17.3925 24.9794 17.64C24.9276 18.1125 24.9622 18.6017 25.1005 19.0567Z",
                fill: "url(#paint11_radial_259_2474)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21.4147 23.3334H18.1201V29.1667H21.4147V23.3334Z",
                fill: "url(#paint12_radial_259_2474)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21.4148 28.3333H18.1202L18.1186 28.3316C17.6203 27.5758 17.6203 24.925 18.1186 24.1691L18.1202 24.1666H21.4148L21.4165 24.1683C21.9148 24.9241 21.9148 27.575 21.4165 28.3308L21.4148 28.3333Z",
                fill: "url(#paint13_radial_259_2474)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22.2385 29.5125H19.7675H17.2966C17.2966 29.5125 15.2639 30.5491 14.8257 31.4275C14.8257 31.4275 14.8257 31.9191 14.8257 32.0125C14.8257 32.8458 18.9439 32.8458 19.7675 32.8458C20.5912 32.8458 24.7094 32.8458 24.7094 32.0125C24.7094 31.92 24.7094 31.4275 24.7094 31.4275C24.277 30.5491 22.2385 29.5125 22.2385 29.5125Z",
                fill: "url(#paint14_linear_259_2474)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M24.7094 31.425C24.7094 32 22.3126 32.1416 20.8136 32.175C20.3441 32.1833 19.9652 32.1833 19.7675 32.1833C19.2898 32.1833 17.692 32.1833 16.44 32.0333C15.5423 31.925 14.8257 31.7416 14.8257 31.425C14.8257 30.675 17.346 29.1666 17.346 29.1666H22.1891C22.1891 29.1666 24.7094 30.675 24.7094 31.425Z",
                fill: "url(#paint15_radial_259_2474)"
            }),
            /*#__PURE__*/ _jsx("path", {
                opacity: "0.7",
                d: "M24.7094 31.425C24.7094 32 22.3126 32.1416 20.8136 32.175C20.3441 32.1833 19.9652 32.1833 19.7675 32.1833C19.2898 32.1833 17.692 32.1833 16.44 32.0333C15.5423 31.925 14.8257 31.7416 14.8257 31.425C14.8257 30.675 17.346 29.1666 17.346 29.1666H22.1891C22.1891 29.1666 24.7094 30.675 24.7094 31.425Z",
                fill: "url(#paint16_radial_259_2474)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.1203 22.5H21.4148C21.8695 22.5 22.2385 22.8733 22.2385 23.3333C22.2385 23.7933 21.8695 24.1667 21.4148 24.1667H18.1203C17.6656 24.1667 17.2966 23.7933 17.2966 23.3333C17.2966 22.8733 17.6656 22.5 18.1203 22.5Z",
                fill: "url(#paint17_radial_259_2474)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.8789 28.3334H21.6553C21.9773 28.3334 22.2384 28.5975 22.2384 28.9225C22.2384 29.2484 21.9773 29.5117 21.6561 29.5117H17.8797C17.5576 29.5117 17.2974 29.2475 17.2974 28.9225C17.2965 28.5975 17.5576 28.3334 17.8789 28.3334Z",
                fill: "url(#paint18_radial_259_2474)"
            }),
            /*#__PURE__*/ _jsx("path", {
                opacity: "0.2",
                d: "M18.1203 22.5H21.4148C21.8695 22.5 22.2385 22.8733 22.2385 23.3333C22.2385 23.7933 21.8695 24.1667 21.4148 24.1667H18.1203C17.6656 24.1667 17.2966 23.7933 17.2966 23.3333C17.2966 22.8733 17.6656 22.5 18.1203 22.5Z",
                fill: "url(#paint19_radial_259_2474)"
            }),
            /*#__PURE__*/ _jsx("path", {
                opacity: "0.3",
                d: "M17.8789 28.3334H21.6553C21.9773 28.3334 22.2384 28.5975 22.2384 28.9225C22.2384 29.2484 21.9773 29.5117 21.6561 29.5117H17.8797C17.5576 29.5117 17.2974 29.2475 17.2974 28.9225C17.2965 28.5975 17.5576 28.3334 17.8789 28.3334Z",
                fill: "url(#paint20_radial_259_2474)"
            }),
            /*#__PURE__*/ _jsx("path", {
                opacity: "0.9",
                d: "M20.8135 32.1666V32.1749C20.344 32.1833 19.9651 32.1833 19.7675 32.1833C19.2897 32.1833 17.6919 32.1833 16.4399 32.0333C18.6226 30.7833 18.4579 29.5083 18.4579 29.5083C18.5567 29.3916 18.6226 29.2749 18.6638 29.1666C18.8615 28.6749 18.4826 28.3333 18.4826 28.3333C19.3145 27.3833 18.6885 24.1666 18.6885 24.1666C19.0245 23.7099 18.8343 22.8391 18.8343 22.8391H19.8992C19.3334 23.6166 19.7675 24.1666 19.7675 24.1666C19.1168 25.6916 19.8251 28.3499 19.8251 28.3499C19.5698 28.6499 19.5368 28.9499 19.578 29.1666C19.6027 29.3583 19.6851 29.4916 19.6851 29.4916C19.0509 31.1749 20.8135 32.1666 20.8135 32.1666Z",
                fill: "url(#paint21_linear_259_2474)"
            }),
            /*#__PURE__*/ _jsx("path", {
                opacity: "0.7",
                d: "M21.4148 28.3333H18.1202L18.1186 28.3316C17.6203 27.5758 17.6203 24.925 18.1186 24.1691L18.1202 24.1666H21.4148L21.4165 24.1683C21.9148 24.9241 21.9148 27.575 21.4165 28.3308L21.4148 28.3333Z",
                fill: "url(#paint22_radial_259_2474)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M28.8357 4.16663C28.8357 4.42496 28.8275 4.68329 28.8275 4.93329C28.811 5.19163 28.8028 5.44996 28.7863 5.69996V5.70829C28.7698 6.08329 28.7369 6.45829 28.6957 6.82496C27.8144 15.525 22.8478 22.8416 20.5993 22.8416H18.952C16.7364 22.8416 11.8604 15.6916 10.8968 7.16663C10.8309 6.67496 10.7897 6.18329 10.765 5.67496V5.66663C10.732 5.16663 10.7156 4.67496 10.7156 4.16663C10.7156 3.90829 10.8391 3.66663 11.0533 3.44996C11.2345 3.26663 11.4733 3.09996 11.7616 2.95829C11.9016 2.88329 12.0581 2.81663 12.2228 2.74163C14.0102 2.02496 17.0659 1.66663 19.7674 1.66663C23.2432 1.66663 27.3038 2.25829 28.4898 3.44996C28.7122 3.65829 28.8357 3.89996 28.8357 4.16663Z",
                fill: "url(#paint23_radial_259_2474)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M27.5016 5.92423V5.98256C27.4769 13.3826 22.1726 19.1409 19.8993 19.1409H18.3756C16.1023 19.1409 10.7898 13.3826 10.7651 5.98256V5.92423C10.7651 5.02423 14.0021 3.66589 19.7676 3.66589C20.7642 3.66589 21.8184 3.75756 22.8315 3.92423C22.848 3.92423 22.8645 3.93256 22.8809 3.93256C25.4672 4.55756 27.5016 5.02423 27.5016 5.92423Z",
                fill: "url(#paint24_radial_259_2474)"
            }),
            /*#__PURE__*/ _jsx("path", {
                opacity: "0.7",
                d: "M27.5016 5.10001V5.15834C27.4769 12.5583 22.1726 18.3167 19.8993 18.3167H18.3756C16.1023 18.3167 10.7898 12.5583 10.7651 5.15834V5.10001C10.7651 4.20001 14.0021 2.84167 19.7676 2.84167C20.7642 2.84167 21.8184 2.93334 22.8315 3.10001C25.4425 3.72501 27.5016 4.19167 27.5016 5.10001Z",
                fill: "url(#paint25_radial_259_2474)"
            }),
            /*#__PURE__*/ _jsx("path", {
                opacity: "0.7",
                d: "M28.7865 5.70005C28.77 6.07505 28.737 6.45838 28.6959 6.82505H27.5016C25.6484 6.80838 22.3126 6.80005 20.5912 6.80005H18.9439C16.7613 6.80005 11.9677 7.13338 10.8969 7.16672C10.831 6.67505 10.7898 6.18338 10.7651 5.67505C11.3005 4.60005 15.8388 3.67505 19.7676 3.67505C23.721 3.67505 28.3005 4.61672 28.7865 5.70005Z",
                fill: "url(#paint26_radial_259_2474)"
            }),
            /*#__PURE__*/ _jsx("path", {
                opacity: "0.7",
                d: "M28.8274 4.16663C28.8274 4.46663 28.8192 5.54163 28.811 5.83329C28.8241 5.37913 26.5888 3.68329 19.6059 3.68329C13.59 3.68329 10.7246 5.24579 10.774 5.73913C10.774 5.73913 10.7073 4.46663 10.7073 4.16663C10.7073 2.49996 15.6491 1.66663 19.7674 1.66663C23.8856 1.66663 28.8274 2.49996 28.8274 4.16663Z",
                fill: "url(#paint27_radial_259_2474)"
            }),
            /*#__PURE__*/ _jsx("path", {
                opacity: "0.7",
                d: "M28.8275 4.16663V4.93329C28.811 5.19163 28.8028 5.44996 28.7863 5.69996C28.2839 4.61663 23.5644 3.67496 19.7674 3.67496C16.0116 3.67496 11.3415 4.59163 10.765 5.66663C10.732 5.16663 10.7156 4.67496 10.7156 4.16663C10.7156 3.90829 10.8391 3.66663 11.0533 3.44996C11.2345 3.26663 11.4733 3.09996 11.7616 2.95829C11.9016 2.88329 12.0581 2.81663 12.2228 2.74163C14.0101 2.02496 17.0659 1.66663 19.7674 1.66663C23.2432 1.66663 27.3038 2.25829 28.4898 3.44996C28.7039 3.66663 28.8275 3.90829 28.8275 4.16663Z",
                fill: "url(#paint28_radial_259_2474)"
            }),
            /*#__PURE__*/ _jsx("path", {
                opacity: "0.6",
                d: "M19.7757 1.66663C15.6574 1.66663 10.7156 2.49996 10.7156 4.16663C10.7156 14.1666 16.4811 22.8391 18.952 22.8391H20.5993C23.0702 22.8391 28.8357 14.1666 28.8357 4.16663C28.8357 2.49996 23.8939 1.66663 19.7757 1.66663Z",
                fill: "url(#paint29_radial_259_2474)"
            }),
            /*#__PURE__*/ _jsx("path", {
                opacity: "0.2",
                d: "M19.7757 2.5C15.6574 2.5 10.7156 2.5 10.7156 4.16667C10.7156 14.1667 16.4811 22.8392 18.952 22.8392H20.5993C23.0702 22.8392 28.8357 14.1667 28.8357 4.16667C28.8357 2.5 23.8939 2.5 19.7757 2.5Z",
                fill: "url(#paint30_radial_259_2474)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M31.1655 0.654175C31.2688 0.409834 31.615 0.409834 31.7183 0.654176L32.0161 1.35922C32.0465 1.43117 32.1038 1.48843 32.1757 1.51883L32.8807 1.81667C33.1251 1.91989 33.1251 2.26616 32.8807 2.36938L32.1757 2.66722C32.1038 2.69761 32.0465 2.75487 32.0161 2.82683L31.7183 3.53187C31.615 3.77621 31.2688 3.77621 31.1655 3.53187L30.8677 2.82683C30.8373 2.75487 30.78 2.69761 30.7081 2.66722L30.0031 2.36938C29.7587 2.26616 29.7587 1.91989 30.0031 1.81667L30.7081 1.51883C30.78 1.48843 30.8373 1.43117 30.8677 1.35922L31.1655 0.654175Z",
                fill: "#FEE485"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.49115 18.7937C3.59437 18.5494 3.94064 18.5494 4.04386 18.7937L4.5489 19.9892C4.57929 20.0612 4.63655 20.1184 4.70851 20.1488L5.90403 20.6539C6.14837 20.7571 6.14837 21.1034 5.90403 21.2066L4.70851 21.7116C4.63655 21.742 4.57929 21.7993 4.5489 21.8712L4.04386 23.0667C3.94064 23.3111 3.59437 23.3111 3.49115 23.0667L2.98611 21.8712C2.95571 21.7993 2.89845 21.742 2.8265 21.7116L1.63098 21.2066C1.38664 21.1034 1.38664 20.7571 1.63098 20.6539L2.8265 20.1488C2.89845 20.1184 2.95571 20.0612 2.98611 19.9892L3.49115 18.7937Z",
                fill: "#FEE485"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M33.2587 23.4448C33.3619 23.2005 33.7082 23.2005 33.8114 23.4448L34.0402 23.9864C34.0706 24.0583 34.1278 24.1156 34.1998 24.146L34.7413 24.3748C34.9857 24.478 34.9857 24.8242 34.7413 24.9275L34.1998 25.1562C34.1278 25.1866 34.0706 25.2439 34.0402 25.3159L33.8114 25.8574C33.7082 26.1017 33.3619 26.1017 33.2587 25.8574L33.0299 25.3159C32.9995 25.2439 32.9422 25.1866 32.8703 25.1562L32.3287 24.9275C32.0844 24.8242 32.0844 24.478 32.3287 24.3748L32.8703 24.146C32.9422 24.1156 32.9995 24.0583 33.0299 23.9864L33.2587 23.4448Z",
                fill: "#FEE485"
            }),
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint0_linear_259_2474",
                        x1: "19.7651",
                        y1: "37.1634",
                        x2: "19.7651",
                        y2: "26.72",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#B65000"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.342",
                                stopColor: "#A44200"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.974",
                                stopColor: "#782100"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint1_linear_259_2474",
                        x1: "19.6875",
                        y1: "29.6366",
                        x2: "19.9379",
                        y2: "41.6223",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#B65000"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.277",
                                stopColor: "#983900"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.549",
                                stopColor: "#812700"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.719",
                                stopColor: "#782100"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint2_linear_259_2474",
                        x1: "19.7271",
                        y1: "33.5383",
                        x2: "20.0686",
                        y2: "28.3647",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#B65000"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.342",
                                stopColor: "#A44200"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.974",
                                stopColor: "#782100"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint3_linear_259_2474",
                        x1: "19.6892",
                        y1: "31.97",
                        x2: "19.9894",
                        y2: "46.2999",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#B65000"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.277",
                                stopColor: "#983900"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.549",
                                stopColor: "#812700"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.719",
                                stopColor: "#782100"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint4_linear_259_2474",
                        x1: "7.07842",
                        y1: "5.60002",
                        x2: "12.0035",
                        y2: "17.5824",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#F2AC32"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#DE9104"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint5_radial_259_2474",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(10.2341 11.7732) rotate(68.0668) scale(6.5401 3.38041)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#E37900"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.875",
                                stopColor: "#E37900",
                                stopOpacity: "0.125"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#E37900",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint6_radial_259_2474",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(16.5257 15.1227) rotate(112.412) scale(6.54141 4.54964)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#E37900"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#E37900",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint7_radial_259_2474",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(6.92234 5.85091) rotate(43.0445) scale(2.46201 6.29647)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FFEEB3"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint8_linear_259_2474",
                        x1: "32.4564",
                        y1: "5.60002",
                        x2: "27.5313",
                        y2: "17.5824",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#F2AC32"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#DE9104"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint9_radial_259_2474",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(29.3008 11.7732) rotate(111.933) scale(6.5401 3.38041)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#E37900"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.875",
                                stopColor: "#E37900",
                                stopOpacity: "0.125"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#E37900",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint10_radial_259_2474",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(23.0095 15.1235) rotate(67.5878) scale(6.54058 4.54906)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#E37900"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#E37900",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint11_radial_259_2474",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(32.8061 5.63849) rotate(113.52) scale(1.88229 4.77172)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FFEEB3"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint12_radial_259_2474",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(19.2665 27.8917) rotate(90.47) scale(5.63936 4.79179)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FEDD30"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.126",
                                stopColor: "#FACB27"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.378",
                                stopColor: "#EF9B10"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.392",
                                stopColor: "#EE980F"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.474",
                                stopColor: "#DF8808"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.588",
                                stopColor: "#CE7500"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint13_radial_259_2474",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(19.1531 27.4233) rotate(90.47) scale(6.30938 5.36112)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FEDD30"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.126",
                                stopColor: "#FACB27"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.378",
                                stopColor: "#EF9B10"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.392",
                                stopColor: "#EE980F"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.474",
                                stopColor: "#DF8808"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.588",
                                stopColor: "#CE7500"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint14_linear_259_2474",
                        x1: "10.1457",
                        y1: "30.9516",
                        x2: "24.4155",
                        y2: "31.2512",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.153",
                                stopColor: "#F1B133"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.301",
                                stopColor: "#E19925"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.447",
                                stopColor: "#D7881B"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.557",
                                stopColor: "#D38218"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.974",
                                stopColor: "#BA6000"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint15_radial_259_2474",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(17.4472 31.6465) rotate(89.0203) scale(3.67684 9.78472)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FEDD30"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.183",
                                stopColor: "#FACB27"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.552",
                                stopColor: "#EF9B10"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.573",
                                stopColor: "#EE980F"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.627",
                                stopColor: "#DF8808"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.702",
                                stopColor: "#CE7500"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint16_radial_259_2474",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(18.4533 30.9412) rotate(3.3641) scale(2.41663 1.97489)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FFEEB3"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint17_radial_259_2474",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(19.0244 23.1731) rotate(0.539104) scale(7.75659 2.21623)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FEDD30"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.123",
                                stopColor: "#FACB27"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.371",
                                stopColor: "#EF9B10"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.385",
                                stopColor: "#EE980F"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.496",
                                stopColor: "#DF8808"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.649",
                                stopColor: "#CE7500"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint18_radial_259_2474",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(18.7317 29.0417) rotate(90.6644) scale(1.67901 19.4042)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FEDD30"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.08",
                                stopColor: "#FACB27"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.242",
                                stopColor: "#EF9B10"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.251",
                                stopColor: "#EE980F"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.383",
                                stopColor: "#DF8808"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.565",
                                stopColor: "#CE7500"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint19_radial_259_2474",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(19.2628 23.0468) rotate(92.7986) scale(2.31665 0.914512)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FFEEB3"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint20_radial_259_2474",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(19.111 29.0243) rotate(2.37944) scale(1.97756 1.14509)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FFEEB3"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint21_linear_259_2474",
                        x1: "18.6267",
                        y1: "81.6358",
                        x2: "18.6267",
                        y2: "-0.822558",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FFEEB3",
                                stopOpacity: "0.5"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint22_radial_259_2474",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(19.2279 26.617) rotate(3.3641) scale(1.9875 4.47945)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FFEEB3",
                                stopOpacity: "0.5"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint23_radial_259_2474",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(16.1984 9.54933) rotate(95.3031) scale(15.1565 13.2059)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FEDD30"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.264",
                                stopColor: "#FACB27"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.793",
                                stopColor: "#EF9B10"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.823",
                                stopColor: "#EE980F"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.886",
                                stopColor: "#DF8808"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.974",
                                stopColor: "#CE7500"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint24_radial_259_2474",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(17.7422 8.03745) rotate(81.9416) scale(10.0852 6.85546)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FFDE6E"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FFDE6C",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint25_radial_259_2474",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(16.5848 8.04966) rotate(82.4736) scale(5.27568 4.8723)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FFEEB3"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint26_radial_259_2474",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(19.8804 14.6027) rotate(0.0695638) scale(15.9153 10.8289)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#CE7500",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.777",
                                stopColor: "#CE7500",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.91",
                                stopColor: "#CE7500",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#CE7500",
                                stopOpacity: "0.7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint27_radial_259_2474",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(15.5361 2.70888) rotate(-12.7581) scale(6.57582 2.10963)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FFEEB3"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint28_radial_259_2474",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(25.2445 0.426918) rotate(37.8933) scale(6.11411 4.60026)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FFEEB3"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint29_radial_259_2474",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(16.8239 7.92978) rotate(-91.6934) scale(26.6193 15.6688)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#D58619",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.323",
                                stopColor: "#D58619",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.491",
                                stopColor: "#D98107",
                                stopOpacity: "0.68"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.495",
                                stopColor: "#D98106",
                                stopOpacity: "0.7"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.681",
                                stopColor: "#D58618",
                                stopOpacity: "0.02"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.686",
                                stopColor: "#D58619",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#D58619",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint30_radial_259_2474",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(19.0498 7.70305) rotate(-91.0647) scale(30.86 15.028)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FFEEB3",
                                stopOpacity: "0.043"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.173",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0.043"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.25",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0.043"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.391",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0.043"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.495",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0.7"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.6",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.795",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.859",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
export default Icon;
